import { ActionReducerMap, createFeatureSelector } from '@ngrx/store'

import { ScopeConfigurationState } from '@app/features/scope-overview/model/scope-configuration/scope-configuration.state.model'
import { ScopeOverviewState } from '@app/features/scope-overview/model/scope-overview.state.model'
import { scopeConfigurationReducer } from './scope-configuration.reducer'
import { scopeOverviewReducer } from './scope-overview.reducer'

export const featureKey = 'scope-overview'

export interface State {
  scopeOverview: ScopeOverviewState
  scopeConfiguration: ScopeConfigurationState
}

export const reducers: ActionReducerMap<State> = {
  scopeOverview: scopeOverviewReducer,
  scopeConfiguration: scopeConfigurationReducer,
}

export const getScopeOverviewState = createFeatureSelector<State>('scope-overview')
export const getScopeConfigurationState = createFeatureSelector<State>('scope-configuration')
